import { doc, updateDoc, getDocs, collection, query, where } from "firebase/firestore";

const UID_RETRY_LIMIT = 10;
const PUBLIC_SITE_URL = "https://mytassel.com";

const isUidAvailable = async (db, uid) => {
	const snapshot = await getDocs(query(collection(db, "users"), where("uid", "==", uid)));
	return snapshot.empty;
};

const generateUidWithPrefix = (prefix) => `${prefix}${Math.floor(Math.random() * 100000).toString().padStart(5, "0")}`;

/** Returns `desiredUid` when free (or already owned by the user), otherwise a fresh unique uid with the same prefix. */
export const resolveAvailableUid = async (db, { desiredUid, currentUid }) => {
	if (desiredUid === currentUid || (await isUidAvailable(db, desiredUid))) return desiredUid;

	for (let attempt = 0; attempt < UID_RETRY_LIMIT; attempt++) {
		const candidate = generateUidWithPrefix(desiredUid.charAt(0));
		if (await isUidAvailable(db, candidate)) return candidate;
	}
	throw new Error("Could not generate a unique account ID.");
};

/**
 * Writes only the fields an account type change owns (field-level update, never a whole-document
 * overwrite) and returns the same changes shaped for the local user data.
 */
export const saveAccountTypeChange = async (db, email, { uid, accountType, clearNewAccount }) => {
	const pages = {
		events: `${PUBLIC_SITE_URL}/events/${uid}`,
		registry: `${PUBLIC_SITE_URL}/registry/${uid}`,
	};
	const newAccountFields = clearNewAccount ? { newAccount: false } : {};

	await updateDoc(doc(db, "users", email), {
		uid,
		accountType,
		"pages.events": pages.events,
		"pages.registry": pages.registry,
		...newAccountFields,
	});

	return { uid, accountType, pages, ...newAccountFields };
};

export const applyAccountTypeChangeToUserData = (userData, changes) => ({
	...userData,
	...changes,
	pages: { ...userData?.pages, ...changes.pages },
});
